import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams ,useLocation} from 'react-router-dom';
import { toast } from 'react-toastify';

const PaymentSuccess = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [verifying, setVerifying] = useState(true);
    const [paymentDetails, setPaymentDetails] = useState(null);
    const [error, setError] = useState(null);

    const location = useLocation();
    // useEffect(() => {
    //     const verifyPayment = async () => {
    //         const sessionId = searchParams.get('session_id');
    //         console.log(sessionId);
            
    //         // if (!sessionId) {
    //         //     setError('No session ID found');
    //         //     setVerifying(false);
    //         //     return;
    //         // }

    //         try {
    //             // const response = await fetch(`http://localhost:5000/api/payments/verify-session/${sessionId}`);
    //             const response = await fetch(`/api/payments/verify-session/${sessionId}`);
    //             const data = await response.json();
    //             console.log(data);

    //             if (response.ok) {
    //                 setPaymentDetails(data);
                    
    //                 // Update local storage to reflect subscription status
    //                 localStorage.setItem('isSubscribed', 'true');
    //                 localStorage.setItem('subscriptionType', 'premium');
    //                 localStorage.setItem('paymentDate', new Date().toISOString());
    //             } else {
    //                 setError(data.error || 'Failed to verify payment');
    //             }
    //         } catch (err) {
    //             setError('Network error while verifying payment');
    //             console.error('Payment verification error:', err);
    //         } finally {
    //             setVerifying(false);
    //         }
    //     };

    //     verifyPayment();
    // }, [searchParams]);


      const handleUpgrade = async () => {
    const authToken = localStorage.getItem('authToken'); // Ensure token is set
    console.log('Auth Token:', authToken); // Debugging log
     console.log('https://beta.flowlogic.com/api/users/subscription/add/'); // Debugging log


    if (!authToken) {
      toast.error('Authentication token not found.');
      return;
    }

    try {
      const response = await fetch('https://beta.flowlogic.com/api/users/subscription/add/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (!response.ok) {
        const data = await response.json();
        console.error('Upgrade failed:', data.message || 'Unknown error');
        toast.error(data.message || 'Subscription upgrade failed');
        return;
      }

      localStorage.setItem('isSubscribed', 'true');
      toast.success('You have successfully upgraded to a paid user');
    //   window.location.reload();
    } catch (error) {
      console.error('Network error during upgrade:', error);
      toast.error('Network error while upgrading');
    }

     
  };

  useEffect(() => {
    handleUpgrade(); // call on mount
  }, []);

    useEffect(() => {
        const verifyPayment = async () => {
            const sessionId = searchParams.get('session_id');
            console.log('Session ID:', sessionId);
            
            // Check for payment data from PaymentForm navigation
            const paymentData = location.state;
            console.log('Payment data from state:', paymentData);
            
            if (sessionId) {
                // Handle Stripe Checkout verification (from StripeIntegration)
                try {
                    const response = await fetch(`/api/payments/verify-session/${sessionId}`);
                    const data = await response.json();
                    console.log('Session verification response:', data);
    
                    if (response.ok) {
                        setPaymentDetails({
                            amount_total: data.amount_total,
                            Id: paymentData.paymentIntent.id,
                            currency: data.currency,
                            customer_email: data.customer_email,
                            payment_status: data.payment_status,
                            source: 'checkout'
                        });
                        
                        // Update local storage
                        localStorage.setItem('isSubscribed', 'true');
                        localStorage.setItem('subscriptionType', 'premium');
                        localStorage.setItem('paymentDate', new Date().toISOString());
                    } else {
                        setError(data.error || 'Failed to verify payment');
                    }
                } catch (err) {
                    setError('Network error while verifying payment');
                    console.error('Payment verification error:', err);
                }
            } else if (paymentData && paymentData.paymentIntent) {
                // Handle Payment Intent data from PaymentForm
                console.log('Processing Payment Intent data:', paymentData.paymentIntent);
                
                setPaymentDetails({
                    amount_total: paymentData.paymentIntent.amount,
                    Id: paymentData.paymentIntent.id,
                    currency: paymentData.paymentIntent.currency,
                    payment_status: paymentData.paymentIntent.status,
                    description: paymentData.description,
                    source: 'payment_form'
                });
                
                // Update local storage
                localStorage.setItem('isSubscribed', 'true');
                localStorage.setItem('subscriptionType', 'premium');
                localStorage.setItem('paymentDate', new Date().toISOString());
            } else {
                setError('No payment information found. Please try again.');
            }
            
            setVerifying(false);
        };
    
        verifyPayment();
    }, [searchParams, location.state]);

    const handleContinue = () => {
        // Navigate to main app or dashboard
        navigate('/dashboard');
        // navigate('/points'); 
    };

    if (verifying) {
        return (
            <div style={{ padding: '40px', textAlign: 'center' }}>
                <h2>Verifying Payment...</h2>
                <div style={{ margin: '20px 0' }}>
                    <div className="spinner">Loading...</div>
                </div>
            </div>
        );
    }
    

    if (error) {
        return (
            <div style={{ padding: '40px', textAlign: 'center' }}>
                <h2 style={{ color: '#e74c3c' }}>Payment Verification Failed</h2>
                <p>{error}</p>
                <button 
                    // onClick={() => navigate('/pricing')}
                    onClick={() => navigate('/pricing')}
                    style={{
                        padding: '12px 24px',
                        backgroundColor: '#3498db',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer'
                    }}
                >
                    Try Again
                </button>
            </div>
        );
    }

    return (
        <div style={{ padding: '40px', textAlign: 'center', maxWidth: '600px', margin: '0 auto' }}>
            <div style={{ marginBottom: '30px' }}>
                <div style={{ fontSize: '48px', color: '#27ae60', marginBottom: '20px' }}>✓</div>
                <h1 style={{ color: '#27ae60' }}>Payment Successful!</h1>
                <p style={{ fontSize: '18px', color: '#666' }}>
                    Thank you for upgrading to Premium!
                </p>
            </div>

            {/* {paymentDetails && (
                <div style={{ 
                    backgroundColor: '#f8f9fa', 
                    padding: '20px', 
                    borderRadius: '8px', 
                    marginBottom: '30px',
                    textAlign: 'left'
                }}>
                    <h3>Payment Details</h3>
                    <p><strong>Amount:</strong> ${(paymentDetails.amount_total / 100).toFixed(2)} {paymentDetails.currency?.toUpperCase()}</p>
                    {paymentDetails.customer_email && (
                        <p><strong>Email:</strong> {paymentDetails.customer_email}</p>
                    )}
                    <p><strong>Status:</strong> <span style={{ color: '#27ae60' }}>Paid</span></p>
                    <p><strong>Subscription:</strong> Premium Access Activated</p>
                </div>
            )} */}

{paymentDetails && (
    <div style={{ 
        backgroundColor: '#f8f9fa', 
        padding: '20px', 
        borderRadius: '8px', 
        marginBottom: '30px',
        textAlign: 'left'
    }}>
        <h3>Payment Details</h3>
        <p><strong>Amount:</strong> ${(paymentDetails.amount_total / 100).toFixed(2)} {paymentDetails.currency?.toUpperCase()}</p>
        {paymentDetails.customer_email && (
            <p><strong>Email:</strong> {paymentDetails.customer_email}</p>
        )}
         <p><strong>Transaction Id:</strong> <span style={{ color: '#27ae60' }}>{paymentDetails.Id}</span></p>
        <p><strong>Status:</strong> <span style={{ color: '#27ae60' }}>{paymentDetails.payment_status}</span></p>
        {paymentDetails.source === 'payment_form' && paymentDetails.description && (
            <p><strong>Description:</strong> {paymentDetails.description}</p>
        )}
        <p><strong>Subscription:</strong> Premium Access Activated</p>
        <p><strong>Source:</strong> {paymentDetails.source === 'checkout' ? 'Stripe Checkout' : 'Payment Form'}</p>
    </div>
)}

            <div style={{ marginTop: '30px' }}>
                <button 
                    onClick={handleContinue}
                    style={{
                        padding: '15px 30px',
                        fontSize: '16px',
                        backgroundColor: '#27ae60',
                        color: 'white',
                        border: 'none',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        marginRight: '15px'
                    }}
                >
                    Continue to Dashboard
                </button>
                
                <button 
                    // onClick={() => navigate('/points')}
                    onClick={() => navigate('/dashboard')}
                    style={{
                        padding: '15px 30px',
                        fontSize: '16px',
                        backgroundColor: 'transparent',
                        color: '#3498db',
                        border: '2px solid #3498db',
                        borderRadius: '6px',
                        cursor: 'pointer'
                    }}
                >
                    Go to Home
                </button>
            </div>

            <div style={{ marginTop: '40px', fontSize: '14px', color: '#888' }}>
                <p>You will receive a confirmation email shortly.</p>
                <p>If you have any questions, please contact our support team.</p>
            </div>
        </div>
    );
};

export default PaymentSuccess;
